import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


const initialState: { systemFlagSliceIds: number[], isReset: boolean } = { systemFlagSliceIds: [], isReset: false }

const SystemFlagSlice = createSlice({
    name: 'SystemFlag',
    initialState,
    reducers: {
        SET_SYSTEMFLAG_IDS(state, action: PayloadAction<any>) {
            state.systemFlagSliceIds = action.payload
            state.isReset = false
        },
        RESET_SYSTEMFLAG_ID(state, action: PayloadAction<any>) {
            state.systemFlagSliceIds = action.payload
            state.isReset = true
        }
    },
})

export const { SET_SYSTEMFLAG_IDS, RESET_SYSTEMFLAG_ID } = SystemFlagSlice.actions
export default SystemFlagSlice.reducer